export const checkIsValid=(fileData:string)=>{
    if (
      fileData?.length > 0 &&
      fileData !== "<p><br></p>" &&
      fileData !== "<h1><br></h1>" &&
      fileData !== "<h2><br></h2>" &&
      fileData !== "<h3><br></h3>" &&
      fileData !== "<h4><br></h4>" &&
      fileData !== "<h5><br></h5>" &&
      fileData !== "<h6><br></h6>" &&
      fileData!== `<p class="ql-align-center"><br></p>` &&
      fileData !==`<p class="ql-align-right"><br></p>` &&
      fileData!== `<p class="ql-align-justify"><br></p>` &&
      fileData !== "<blockquote><br></blockquote>" && 
      fileData !== `<p class="ql-align-right ql-direction-rtl"><br></p>` &&
      fileData !== `<p class="ql-align-right ql-direction-rtl"><br></p>`
    ){
      return true
    }else{
      return false
    }
  }